export const WORK_CONST = {
  CYCLES_INTERN: 6,
  CYCLES_FREELANCE: 6,
} as const;
